
class LangSwitcher {
  constructor(wrapper) {
    this.wrapper = wrapper;
    console.log(this.wrapper);

    if (!this.wrapper) return;

    this.button = this.wrapper.querySelector(".localization__button");
    this.dropdown = this.wrapper.querySelector(".localization__dropdown");
    this.dropdownItems = this.dropdown.querySelectorAll(".localization__item");

    // Get stored language or use default
    this.currentLocale = localStorage.getItem("selectedLocale") || "en-en";

    this.init();
    this.addEventListeners();
  }

  init() {
    // Set initial active state based on stored locale
    this.dropdownItems.forEach((item) => {
      if (item.dataset.value === this.currentLocale) {
        item.classList.add("active");
        this.updateButtonText(item.textContent.trim());
      }
    });
  }

  updateButtonText(text) {
    const buttonText = this.button.querySelector(".localization__button-text");
    if (buttonText) {
      buttonText.textContent = text;
    }
  }

  getPathWithoutLocale(path) {
    // Remove locale prefix if it exists (e.g., /fr-fr/, /en-us/)
    return path.replace(/^\/[a-z]{2}-[a-z]{2}(?=-|\/|$)/i, "");
  }

  switchLanguage(locale) {
    if (locale === this.currentLocale) {
      this.wrapper.classList.remove("active");
      return;
    }

    // Store the selected locale
    localStorage.setItem("selectedLocale", locale);
    this.currentLocale = locale;

    // Get current URL and path without locale prefix
    const currentUrl = new URL(window.location.href);
    const cleanPath = this.getPathWithoutLocale(currentUrl.pathname);

    // Construct new path based on locale
    let newPath =
      locale.toLowerCase() === "en-en"
        ? cleanPath
        : `/${locale.toLowerCase()}${cleanPath}`;
    // Ensure path starts with '/' if it doesn't
    if (!newPath.startsWith("/")) newPath = "/" + newPath;

    // Construct new URL maintaining query parameters
    const newUrl = `${currentUrl.origin}${newPath}${currentUrl.search}`;

    // Navigate to new URL
    window.location.href = newUrl;
  }

  addEventListeners() {
    // Toggle dropdown
    this.button.addEventListener("click", (e) => {
      e.stopPropagation();
      this.wrapper.classList.toggle("active");
    });

    // Handle language selection
    this.dropdownItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        const locale = item.dataset.value;

        if (locale) {
          this.switchLanguage(locale);
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.wrapper.classList.remove("active");
      }
    });

    // Handle escape key to close dropdown
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.wrapper.classList.remove("active");
      }
    });
  }
}

// Initialize on DOM content loaded
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("localization-form").forEach((wrapper) => {
    new LangSwitcher(wrapper);
  });
});
